import { render, staticRenderFns } from "./applicant-header-section.vue?vue&type=template&id=19929b50&scoped=true"
import script from "./applicant-header-section.vue?vue&type=script&lang=js"
export * from "./applicant-header-section.vue?vue&type=script&lang=js"
import style0 from "./applicant-header-section.vue?vue&type=style&index=0&id=19929b50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19929b50",
  null
  
)

export default component.exports